define([
	"dojo/_base/declare",
	"SiteAdmin/NewGalleryComment",
	"csi/xml",
	"dojo/text!csi/widget/CommentDialogNode.html"
], function(declare,NewGalleryComment,xml,template) {

	return declare(NewGalleryComment, {
		dialogTemplate: template,

		/** we're going to attach the comment through an operation, so set to false */
		bUpdateParent: false,

		postProcessSuccess: function() {
			// summary: append new top level comment
			return this.widget.addBlocks([this.getNode()], this.widget.getRefNodes()[0], true);
		},

		/**
		 * @override
		 * attach the CommentReply using Java Operation
		 */
		 toWriter: function() {
			this.inherited(arguments);
			const {m_urlNode, m_urlParent, m_writer} = this;

			// attach the reply
			m_writer
				.callMethod("SiteAdmin", "AttachComment")
				.addParameter(xml.PROP_URL_PARENT, xml.ATTR_REF, m_urlParent)
				.addParameter(xml.PROP_URL, xml.ATTR_REF, m_urlNode);
		},
	});
});